import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { wz } from './wizard-tokens';
import { WizGradientButton } from './wizard-ui';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Rückfrage, bevor eine Änderung der Suchkriterien eine neue Kandidatensuche auslöst (DEV-1096). */
const SearchRestartDialog: React.FC<Props> = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: '16px' } }}
    >
      <DialogTitle sx={{ fontSize: 20, fontWeight: 700 }}>{t('wizSearchRestartTitle')}</DialogTitle>
      <DialogContent sx={{ paddingTop: '8px !important' }}>
        <div style={{ fontSize: 15, color: wz.text }}>{t('wizSearchRestartText')}</div>
      </DialogContent>
      <DialogActions sx={{ padding: '0 24px 20px', gap: '12px' }}>
        <button
          type="button"
          onClick={onCancel}
          style={{
            height: 40,
            padding: '0 20px',
            borderRadius: 8,
            fontSize: 15,
            fontWeight: 600,
            color: wz.primary,
            background: '#FFF',
            border: `1.5px solid ${wz.primary}`,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          {t('wizSearchRestartCancel')}
        </button>
        <WizGradientButton onClick={onConfirm}>{t('wizSearchRestartConfirm')}</WizGradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default SearchRestartDialog;
